@if (icon) {
	<fa-icon class="c-cjm-tag__icon" [icon]="icon" [iconType]="iconType" />
}
<span>
	<ng-content></ng-content>
</span>
@if (clearable) {
	<fa-icon
		class="c-cjm-tag__clear_icon"
		cypressTag="General.Tag.Clear"
		icon="fa-times"
		[alt]="i18nKeys.Actions.Clear | translate"
		(focusClick)="clear.emit()"
	/>
}
